import { Component, OnDestroy, OnInit } from '@angular/core';
import { ENDPOINTS } from '../app.config';
import { CompanyService } from '../company.service';
import axios from 'axios';
import { Router } from '@angular/router';
import { ToasterService } from 'angular2-toaster';
import { LangChangeEvent, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-admin',
  templateUrl: './admin.component.html',
  styleUrls: ['./admin.component.css']
})
export class AdminComponent implements OnInit {

  errors: any;
  totalPages: number;
  router: Router;
  companyService: CompanyService;
  newAdminPassword = {
    password: '',
    new_password: '',
    new_password_confirmation: ''
  };
  toaster: ToasterService;
  successMessage: string;

  constructor(
    toaster: ToasterService,
    router: Router,
    companyService: CompanyService,
    private translate: TranslateService
  ) {
    this.toaster = toaster;
    this.errors = [];
    this.router = router;
    this.companyService = companyService;
  }


  ngOnInit() {
    this.translate.stream('SHARED.Messages.password_changed_successfully').subscribe((res: string) => {
      this.successMessage = res;
    });
  }

  updateAdminPassword() {
    const patchPassword = {
      'password': this.newAdminPassword.password,
      'new_password': this.newAdminPassword.new_password,
      'new_password_confirmation': this.newAdminPassword.new_password_confirmation
    };

    const isFormValid = this.doValidation();
    if (isFormValid) {
      axios.put(
        ENDPOINTS.PUT_ADMIN_PASSWORD, patchPassword)
        .then(
          response => {
            this.resetAdminFieldPasswords(this.newAdminPassword);
            console.log(this.successMessage);
            this.toaster.pop('success', this.successMessage);
          },
          error => {
            console.log(error);
            this.toaster.pop('error', error.response.data.message);
          },
        );
    }

  }

  /*
    Utilities
  */

  doValidation() {
    this.errors = [];
    if (!this.newAdminPassword.password) {
      this.errors.push('password');
    }
    if (!this.newAdminPassword.new_password) {
      this.errors.push('new_password');
    }
    if (!this.newAdminPassword.new_password_confirmation) {
      this.errors.push('new_password_confirmation');
    }
    return this.errors.length === 0;
  }

  resetAdminFieldPasswords(newAdminPassword) {
    newAdminPassword.password = '';
    newAdminPassword.new_password = '';
    newAdminPassword.new_password_confirmation = '';
  }

  onEnter(event) {
    this.updateAdminPassword();
  }

}



// WEBPACK FOOTER //
// /Users/mihagresak/Documents/git-projects/vintegras-angular-new-clean/src/app/admin/admin.component.ts